<template>
  <div class="main_style">
    <div class="container">
      <Main_nav />
      <b-row class="mt-5 ml-5 text-left py-2 white-background">
        <b-col>
          <span style="font-size: 24px; font-weight: bolder">
            <b-icon icon="house-door"></b-icon>
            ข้อมูลชุมชน</span
          >
        </b-col>
      </b-row>
      <b-row v-if="user.user.group_id <= 2" class="mt-3">
        <b-col class="font-title" cols="3">ชุมชน :</b-col>
        <b-col cols="9">
          <multiselect
            id="community"
            v-model="community_selected"
            :close-on-select="true"
            :options="communityList"
            class="multiselect-style2 custom-multiselect text-left"
            label="name"
            placeholder="เลือกชุมชน"
            select-label=""
            selectedLabel=""
            track-by="community_id"
            @input="getResult"
          ></multiselect>
        </b-col>
      </b-row>
      <div v-if="community_selected">
        <b-row class="mt-3 ml-5">
          <b-col v-for="item in communityOption" :key="item.id" cols="3">
            <button
              v-if="onlyAdminAllow(item.id)"
              @click="communityState = item.id"
              :class="[
                communityState === item.id
                  ? 'orange-background'
                  : 'none-background',
                'btn btn-block',
              ]"
            >
              {{ item.name }}
            </button>
          </b-col>
        </b-row>
        <CommunityInfo
          :community="selectComunity"
          :onRefresh="onRefresh"
          v-if="communityState === 1"
        ></CommunityInfo>
        <CommunityProgress
          :community="selectComunity.progress"
          :onRefresh="onRefresh"
          v-if="communityState === 2"
        ></CommunityProgress>
        <CommunityProject
          :community="selectComunity.project"
          :onRefresh="onRefresh"
          v-if="communityState === 3 && user.user.group_id <= 2"
        ></CommunityProject>
        <!-- only admin access -->
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import CommunityInfo from "@/components/community_info";
import CommunityProgress from "@/components/community_progress";
import CommunityProject from "@/components/community_project";
import Main_nav from "@/components/navbar";
import { mapState } from "vuex";
import Multiselect from "vue-multiselect";
export default {
  data() {
    return {
      community_id: null,
      community_selected: null,
      communityState: 1,
      communityOption: [
        { id: 1, name: "ข้อมูลทั่วไป" },
        { id: 2, name: "ความก้าวหน้า" },
        { id: 3, name: "ข้อมูลโครงการ" },
      ],
    };
  },
  computed: {
    ...mapState({
      accessToken: (state) => state.AuthModule.accessToken,
      user: (state) => state.AuthModule.userData,
      communityList: (state) => state.communityModule.list_community,
      selectComunity: (state) => state.communityModule.select_comunity,
    }),
  },
  components: {
    Main_nav,
    CommunityInfo,
    CommunityProgress,
    CommunityProject,
    Multiselect,
  },
  created() {
    this.$store.dispatch("communityModule/onGetCommunityList");
    if (this.user.user.group_id === 5 && this.user.user.community_id) {
      this.community_selected = this.user.user.community_id;
      this.community_id = this.user.user.community_id;
      Swal.fire({
        title: "ระบบกำลังทำงาน",
        html: "โปรดรอสักครู่...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch(
              "communityModule/onGetCommunity",
              {community_id : this.user.user.community_id, is_count:null} 
            )
            .then((res) => {
              if (res == 200) {
                Swal.clickConfirm();
              } else {
                Swal.clickConfirm();
              }
            });
        },
      });
    } else if (!this.accessToken) {
      this.$router.push("/");
    }
  },
  methods: {
    onRefresh() {
      this.$store.dispatch("communityModule/onGetCommunity", {community_id : this.community_id, is_count:null});
    },
    onlyAdminAllow(menu) {
      if (menu === 3) {
        if (this.user.user.group_id <= 2) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    getResult() {
      this.community_id = this.community_selected.community_id;
      Swal.fire({
        title: "ระบบกำลังทำงาน",
        html: "โปรดรอสักครู่...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch(
              "communityModule/onGetCommunity",
              {community_id : this.community_selected.community_id, is_count:null} 
            )
            .then((res) => {
              if (res == 200) {
                Swal.clickConfirm();
              } else {
                Swal.clickConfirm();
              }
            });
        },
      });
    },
    uploadFile(event, index) {
      if (event.target.files.length > 0) {
        this.form.progressTemplate[index].file = event.target.files[0].name;
      }
    },
  },
};
</script>

<style>
</style>